import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { AppDispatch } from "app/store";
import I18n from "common/i18n";
import { PiecePreview } from "features/piecePreview";
import { actions } from "./slice";
import { MapMaker } from "./canvas";

export const Builder = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    dispatch(actions.initializeLocalMap());
    setInitialized(true);
  }, [dispatch]);

  if (!initialized) {
    return <div className="flex-col-center w-full h-full">{I18n.t("MSG_LOADING")}</div>;
  }

  return (
    <Routes>
      <Route index element={<MapMaker />} />
      <Route path="preview" element={<PiecePreview />} />
    </Routes>
  );
};
